import React from "react";
import { compose, withProps, lifecycle } from "recompose";
import { withScriptjs, withGoogleMap, GoogleMap } from "react-google-maps";
import googleMapsStylings from "./googleMapStylings.js";
import HeatmapLayer from "react-google-maps/lib/components/visualization/HeatmapLayer";

const MapLocation = compose(
	withProps({
		googleMapURL:
			`https://maps.googleapis.com/maps/api/js?key=AIzaSyAFvGxWf3FY3V3aIfKtnfz7VFN_3PU-ci8&v=3.exp&libraries=geometry,drawing,places,visualization`,
		loadingElement: (
			<div
				style={{
					height: `100%`
				}}
			/>
		),
		containerElement: (
			<div
				style={{
					height: `100%`
				}}
			/>
		),
		mapElement: (
			<div
				style={{
					height: `100%`
				}}
			/>
		),
		center: {
			lat: 44.22862,
			lng: -76.502105
		},
		zoom: 6
	}),
	withScriptjs,
	withGoogleMap,
	lifecycle({
		componentDidMount() {
			var data = [];

			for (let i = 0; i < this.props.location_details.length; i++) {
				data.push(
					new window.google.maps.LatLng(
						this.props.location_details[i].lat,
						this.props.location_details[i].lng
					)
				);
			}

			this.setState({
				data
			});
		}
	})
)(props => (
	<div style={{ height: "100%", position: "relative" }}>
		<GoogleMap
			zoom={props.zoom}
			center={props.center}
			ref={props.zoomToMarkers}
			heatmapLibrary={true}
			heatmap={props.data}
			defaultOptions={{
				styles: googleMapsStylings,
				mapTypeControl: true,
				mapTypeControlOptions: {
					style: {},
					mapTypeIds: ["roadmap", "satellite"]
				}
			}}
		>
			{/* <Marker
				position={{
					lat: 44.227699,
					lng: -76.495277
				}}
				icon={{
					url: "https://img.icons8.com/color/48/000000/university.png"
				}}
			/> */}

			<HeatmapLayer data={props.data} />
		</GoogleMap>
	</div>
));

export default MapLocation;



// WEBPACK FOOTER //
// ./src/components/pages/Analytics/MapLocation.js